module.exports = __webpack_public_path__ + "static/media/acai_berry_serum.cf0e155e.png";